export default "__VITE_ASSET__NPRb2H6g__"